import CatalogTileCard from "../common/catalog/CatalogTileCard";
import { resolveCatalogInstructor } from "../common/catalog/catalogInstructorDisplay";
import { isFreeProduct } from "../common/badge/FreeBadge";
import ClipCatalogTile from "../video_clip/clip/ClipCatalogTile";
import WebinarCardStartMeta from "../webinar/WebinarCardStartMeta";
import { formatWebinarStartLabel } from "../webinar/webinarStartDisplay";
import { useWebinarCardStatusLabel } from "./useWebinarCardStatusLabel";
import { webinarHeroStatusKind } from "./webinarHeroStatus";

function HomeWebinarCarouselCard({ card }) {
	const instructor = resolveCatalogInstructor(card);
	const startLabel = formatWebinarStartLabel(card);
	const statusLabel = useWebinarCardStatusLabel(card.start_datetime, startLabel);
	const statusKind = webinarHeroStatusKind(card.start_datetime);
	const imageTagText =
		statusKind === "countdown" && startLabel ? undefined : statusLabel || undefined;

	return (
		<CatalogTileCard
			to={card.href}
			title={card.title}
			imageUrl={card.image_url}
			actionLabel={card.action_label || "مشاهده"}
			instructorItem={card}
			metaSlot={startLabel ? <WebinarCardStartMeta webinar={card} /> : undefined}
			subtitleMuted={instructor.isEmpty}
			imageTagText={imageTagText}
		/>
	);
}

export default function HomeCarouselCard({ card }) {
	if (!card?.href) {
		return null;
	}

	if (card.kind === "video_clip") {
		return (
			<ClipCatalogTile
				clip={card}
				to={card.href}
				actionLabel={card.action_label || "مشاهده چالش"}
			/>
		);
	}

	if (card.kind === "workshop") {
		const instructor = resolveCatalogInstructor(card);
		return (
			<CatalogTileCard
				to={card.href}
				title={card.title}
				imageUrl={card.image_url}
				actionLabel={card.action_label || "مشاهده"}
				instructorItem={card}
				subtitleMuted={instructor.isEmpty}
				showFreeBadge={isFreeProduct(card)}
			/>
		);
	}

	if (card.kind === "webinar") {
		return <HomeWebinarCarouselCard card={card} />;
	}

	return (
		<CatalogTileCard
			to={card.href}
			title={card.title}
			imageUrl={card.image_url}
			actionLabel={card.action_label || "مشاهده"}
			subtitle={card.subtitle}
			instructorAvatarUrl={card.instructor_avatar_url}
			subtitleMuted={!card.subtitle}
			showFreeBadge={Boolean(card.show_free_badge)}
			showDoctorRow={card.kind === "doctor"}
		/>
	);
}
